















































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import Router from 'vue-router';
// eslint-disable-next-line import/no-extraneous-dependencies
import i18n from 'vue-i18n';
import CoPost from '@/components/Organisms/co-post/CoPost.vue';
import { set, clone, uniq, map, get, uniqueId, isArray, update } from 'lodash';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import EventBus from '@/eventBus';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoMatch from '@/components/Molecules/co-match/CoMatch.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoUserProfileEditor from '@/components/Organisms/co-user-profile-editor/CoUserProfileEditor.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import { formatLinkLabel } from '@/utils/linkLabel';

Vue.use(Router);
export default {
    name: 'ViewProfile',
    components: {
        CoThumbnail,
        CoPost,
        CoText,
        CoButton,
        CoMatch,
        CoHeadline,
        CoUserProfileEditor,
        CoRoundButton,
    },
    data() {
        return {
            user: {},
            isMe: false,

            // feed
            feed: [],
            feedBank: [],
            feedNextPage: null,
            loading: false,
            loadingFeed: false,

            projects: [],
            jobs: null,

            isMarketOn: this.$store.state.space.MarkeplaceOn,

            focusPostID: get(this, '$route.query.focuspostid', ''),
        };
    },
    watch: {
        user(newVal, oldVal) {
            if (newVal) {
                this.feed = [];
                this.feedBank = [];
                this.getFeedForUser(newVal.ID);
                if (this.isPagesEnabled) this.getProjectsForUser(newVal.ID);
                this.getJobsForUser(newVal.ID);
            }
        },
    },
    computed: {
        // PagesOff removes pages from member profiles and avoids their API request.
        isPagesEnabled() {
            return !this.$store?.state?.space?.PagesOff;
        },
        customFields() {
            const fields = [...(this.user.Fields || [])];

            // stable sort by field sort-order and then by name
            return fields.sort((a, b) => {
                if (a.SortOrder === b.SortOrder) {
                    return a.Label.localeCompare(b.Label);
                }
                return a.SortOrder - b.SortOrder;
            });
        },
        currentMe() {
            return this.$store.state.me;
        },
        currentPlanSlug() {
            return this.$store.state.space.PlanSlug;
        },
        currentSpaceID() {
            return this.$store.state.space.ID;
        },
        canEditProfile() {
            return this.user.ID === this.currentMe.ID;
        },
        showProfileMatch() {
            // Matching compares two different members; showing it for the current user's own profile is misleading.
            return this.isMatchingEnabledForSpace && !this.canEditProfile;
        },
        showForeignSpaceHeader() {
            return this.user.Space && this.user.Space.ID !== this.currentSpaceID;
        },

        isMatchingEnabledForSpace() {
            if (!this.$store || !this.$store.state || !this.$store.state.space) {
                return false;
            }

            return !this.$store.state.space.MatchingOff;
        },
        // isUserProfileEmpty() {
        //     // if no interests, no bio, no company and no custom fields values are set, return true
        //     let customFieldsValuesAreEmpty = true;
        //     if (this.user.Fields && this.user.Fields.length > 0) {
        //         customFieldsValuesAreEmpty = this.user.Fields.every(
        //             (field) => !field.Value || field.Value.trim() === ''
        //         );
        //     }
        //     return (
        //         !this.user.Profile.Interests &&
        //         !this.user.Profile.Bio &&
        //         !this.user.Profile.Company &&
        //         !customFieldsValuesAreEmpty
        //     );
        // },
    },
    beforeRouteUpdate(to, from, next) {
        // called when the route that renders this component has changed,
        // but this component is reused in the new route.
        // For example, for a route with dynamic params `/foo/:id`, when we
        // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        // will be reused, and this hook will be called when that happens.
        // has access to `this` component instance.
        const { slug } = to.params;
        this.getUserData(slug);
        next();
    },
    created() {
        const { slug } = this.$route.params;
        this.getUserData(slug);
    },
    mounted() {
        window.addEventListener('scroll', this.scroll);
        this.loading = true;
        this.feed = [];
        this.feedBank = [];
        this.getFeedForUser(this.user.ID);
    },

    destroyed() {
        window.removeEventListener('scroll', this.scroll);
    },
    methods: {
        get,
        formatLinkLabel,
        displayMultiSelectValues(input: string) {
            if (!input) return '';
            // replace commas with ', '
            const output = input.replace(/,/g, ', ');
            return output;
        },
        userUpdated() {
            const { slug } = this.$route.params;
            this.getUserData(slug);
            if (this.$refs.userprofileeditor) {
                this.$refs.userprofileeditor.hide();
            }
        },
        showAllPages() {
            this.$refs.pageslistmodal.show();
        },
        showMarketItems() {
            this.$refs.marketItemsListModal.show();
        },
        showUserProfileEditor() {
            if (this.$refs.userprofileeditor) {
                this.$refs.userprofileeditor.show();
            }
        },
        getUserData(slug) {
            if (slug === 'me') {
                this.$data.isMe = true;
                this.$store
                    .dispatch('getMe', null)
                    .then((response) => {
                        this.user = response.data;
                        if (this.isPagesEnabled) this.getProjectsForUser(this.user.ID);
                        this.getJobsForUser(this.user.ID);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else if (slug.length >= 88) {
                const ids = JSON.stringify({ IDS: [{ ID: slug }] });
                this.$store
                    .dispatch('listUsersByIDs', { ids })
                    .then((response) => {
                        this.$data.user = response.Users[0];
                        if (this.isPagesEnabled) this.getProjectsForUser(this.user.ID);
                        this.getJobsForUser(this.user.ID);
                        this.$router.push(`/profile/${this.$data.user.Slug}`);
                    })
                    .catch((error) => {
                        console.log('error', error);
                    });
            } else {
                this.$store
                    .dispatch('getUserBySlug', slug)
                    .then((response) => {
                        if (this.isPagesEnabled) this.getProjectsForUser(this.user.ID);
                        this.getJobsForUser(this.user.ID);
                        this.$data.user = response;
                    })
                    .catch((error) => {
                        console.log('error ', error);
                        if (error.message.includes('404')) {
                            this.$router.replace('/not-found/user').catch(() => {});
                        }
                    });
            }
        },

        getFeedForUser(userID) {
            this.loadingFeed = true;
            axios({
                method: 'GET',
                url: `/user/profile/feed/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (!response || !response.data || !response.data.objects) {
                        this.loadingFeed = false;
                        return;
                    }

                    let posts = response.data.objects;

                    // filter out the jobs if the market is disabled
                    if (!this.isMarketOn) {
                        posts = posts.filter((item) => item.type !== 'job');
                    }

                    // map content to post object structure
                    const fetchUsers = [];
                    posts.forEach((entry) => {
                        // skip if entry.object does not exist
                        if (!entry.object) return;

                        this.feedBank.push(entry);
                        if (entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID) {
                            fetchUsers.push(entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID);
                        }
                    }, this);

                    // fetch and populate post author info
                    let users = null;
                    try {
                        users = await axios({
                            method: 'POST',
                            url: '/user/listbyids',
                            data: { IDS: map(uniq(fetchUsers), (id) => ({ ID: id })) },
                            withCredentials: true,
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });
                        users = map(users.data.Users, (user) => ({
                            ID: get(user, 'ID'),
                            Name: get(user, 'Profile.Name'),
                            Slug: get(user, 'Slug'),
                            ImageURL: get(user, 'Profile.ImageURL'),
                            Bio: get(user, 'Profile.Bio'),
                        }));
                    } catch (error) {
                        console.log(error);
                    }

                    // map post object to co-post structure
                    this.feedBank.forEach((entry) => {
                        // skip if entry.object does not exist
                        if (!entry.object) return;
                        // assign author infos
                        if (entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID) {
                            entry.object.Author = users.find(
                                (user) =>
                                    user.ID === entry.object.AuthorID ||
                                    user.ID === entry.object.CreatedBy ||
                                    user.ID === entry.object.UserID
                            );
                        }
                        // assign space infos
                        entry.space ? (entry.object.Space = entry.space) : null;
                        // assign images for posts and page-updates (project-updates)
                        let tmpimages = get(entry, 'object.Images', null) || get(entry, 'object.ImageURLs', []);
                        entry.object.Images = map(tmpimages, (i) => ({ ImageURL: i }));
                        // map type
                        if (entry.type === 'Post') {
                            entry.type = 'post';
                        }
                        entry.object.Type = entry.type;
                        // assign parent content

                        if (entry.type !== 'post' || entry.object.ParentType === 1 || entry.object.ParentType === 2) {
                            // generate post text for non post content
                            entry.object.Text ? null : (entry.object.Text = null);
                            // parent content default mapping
                            entry.object.ParentContent = {
                                ...entry.object,
                                Type: entry.type,
                            };

                            if (entry.object.ParentType === 1) {
                                entry.object.ParentContent.Type = 'event';
                            } else if (entry.object.ParentType === 2) {
                                entry.object.ParentContent.Type = 'page-update';
                                entry.object.ParentContent.Fetch = {
                                    ID: entry.object.ParentID,
                                    Type: 'project',
                                };
                            }

                            // specific parent content mapping
                            switch (entry.object.ParentContent.Type) {
                                case 'job':
                                case 'event':
                                case 'market-item':
                                    break;
                                case 'project':
                                    entry.object.ParentContent.Images = isArray(entry.object.ParentContent.ImageURL)
                                        ? map(entry.object.ImageURL, (i) => {
                                              if (typeof i === 'string' && i.match('/img/Platform_Gradients')) {
                                                  return false;
                                              }
                                              return { ImageURL: i };
                                          })
                                        : null;
                                    entry.object.CreatedAt = entry.object.Created;
                                    break;
                                case 'project-update':
                                    entry.object.ParentContent.Fetch = {
                                        ID: entry.object.ProjectID,
                                        Type: 'project',
                                    };
                                    entry.object.CreatedAt = entry.object.Created;
                                    break;
                                default:
                                    break;
                            }
                        }
                    }, this);

                    this.feedBank.sort((a, b) => a.object.Score - b.object.Score);
                    if (this.feedBank.length > 10) {
                        this.feed.push(...this.feedBank.slice(0, 10));
                        this.feedBank = this.feedBank.slice(10);
                    } else {
                        this.feed.push(...this.feedBank);
                        this.feedBank = [];
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingFeed = false;
                });
        },

        getProjectsForUser(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/user/profile/projects/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.projects = response.data.objects; // todo support pagination
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },

        getJobsForUser(userID) {
            if (!this.isMarketOn) {
                this.jobs = [];
                return;
            }

            this.loading = true;
            axios({
                method: 'GET',
                url: `/user/profile/jobs/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.jobs = response.data.objects; // todo support pagination
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },

        takeContact(userObj) {
            const thread = {
                Participants: [this.currentMe.ID, userObj.ID],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$router.push(`/messenger/${response.data.ID}`);
                    }
                    // this.$router.push(`/messenger`);
                })
                .catch((error) => {
                    console.log(error);
                    //  this.$router.push(`/messenger`);
                });

            // var msg = {"msg": ""};
        },

        editPost(post: Object = null) {
            if (!post) return;
            // const postRef = this.$refs['post' + get(post, 'object.ID', '')];
            // if (!postRef || postRef.length < 1) return;
            const that = this;
            EventBus.$emit('EDITPOST', post, function (data: Object = {}) {
                // if post is not in feed, do nothing
                if (!data || !data['ID']) return;
                // remove AuthorID, Author from the data object to preserve the original post structure
                delete data['AuthorID'];
                delete data['Author'];
                // map images to ImageURL structure
                if (data['Images'] && isArray(data['Images'])) {
                    data['Images'] = map(data['Images'], (i) => {
                        if (typeof i === 'string' && i.match('/img/Platform_Gradients')) {
                            return false;
                        }
                        return { ImageURL: i };
                    });
                }
                // update just the post in feed to prevent re-rendering the whole feed
                // find index of post in feed
                const postIndex = that.feed.findIndex((p) => p.object.ID === data['ID']);
                if (postIndex === -1) return;
                // set the updated post object
                const oldPost = that.feed[postIndex];
                oldPost.object = {
                    ...data,
                    Author: oldPost.object?.Author || {},
                    AuthorID: oldPost.object?.AuthorID || null,
                };
                // set flag to true if post was updated
                oldPost.wasUpdated = true;
                // update the post item in feed array
                that.feed[postIndex] = oldPost;
            });
        },

        scrollRefIntoView(ref) {
            const el = get(this, `$refs[${ref}][0]`, {});
            if (el.$el) el.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },

        scroll() {
            window.onscroll = () => {
                const feedContainer = this.$refs.container;
                if (!feedContainer) return;

                // get the distance from the bottom of the page to the bottom of the feed container
                const distanceFromBottom = feedContainer.getBoundingClientRect().bottom - window.innerHeight;

                const percentage = (distanceFromBottom * 100) / feedContainer.clientHeight;

                if (percentage < 10) {
                    if (this.feedBank.length !== 0 && this.feedBank.length > 10) {
                        this.feed.push(...this.feedBank.slice(0, 10));
                        this.feedBank = this.feedBank.slice(10);
                    } else if (this.feedBank.length !== 0 && this.feedBank.length <= 10) {
                        this.feed.push(...this.feedBank);
                        this.feedBank = [];
                    } else if (
                        this.feedBank.length === 0 &&
                        (this.feedNextPage != null || this.nextParams != null) &&
                        !this.loading
                    ) {
                        this.getFeed();
                    }
                }
            };
        },
    },
};
